import React, { useMemo } from 'react';

import { AssemblyMemberPart } from '../../../../store/selectors/assemblyPartsUtilities';
import { applyMemberFilter } from './applyMemberFilter';
import { AssemblyMemberPartDiagram } from './AssemblyMemberPartDiagram';
import { getMemberFilter, PartsFilterSelection } from './getMemberFilter';

interface AssemblyMemberPartDiagramsProps {
  readonly assemblyMemberParts: readonly AssemblyMemberPart[];
  readonly partsFilterSelection: PartsFilterSelection;
  readonly useColoring?: boolean;
}

export function AssemblyMemberPartDiagrams({
  assemblyMemberParts,
  partsFilterSelection,
  useColoring,
}: AssemblyMemberPartDiagramsProps) {
  const memberFilter = useMemo(() => getMemberFilter(partsFilterSelection), [partsFilterSelection]);

  if (memberFilter === null) throw new Error('Trying to display member parts when a member filter is not selected');

  const assemblyPartsWithMemberFilterMatches: readonly AssemblyMemberPart[] = applyMemberFilter(
    assemblyMemberParts,
    memberFilter,
  );

  return (
    <>
      {assemblyPartsWithMemberFilterMatches.map(
        ({ guid, getStandardizedMemberPolygonAtOrigin, memberCuts, membersOfCutAndLength }) => (
          <AssemblyMemberPartDiagram
            getStandardizedMemberPolygonAtOrigin={getStandardizedMemberPolygonAtOrigin}
            memberCuts={memberCuts}
            membersOfCutAndLength={membersOfCutAndLength}
            key={guid}
            useColoring={useColoring}
          />
        ),
      )}
    </>
  );
}
